(function () {
    "use strict";

    function workflowService($resource, URL) {

        var vm = this;
        vm.resource = $resource(URL.URL+'/api/workflow/mydoc/:id/:token/:idWorkflow', { id: '@id', token: '@token', idWorkflow: '@idWorkflow' }, {
            queryWorkflows: {
                method: 'GET',
                isArray: true,
                params: { id: '@id', token: '@token' }
            },
            queryWorkflowData: {
                method: 'GET',
                isArray: true,
                params: { id: '@id', token: '@token', idWorkflow: '@idWorkflow' }
            },
            update: {
                method: 'PUT'
            },
            getToken: {
                method: 'GET',
                isArray: false,
                params: { id: '@id' }
            }
        });

        vm.sphformsResource = $resource(URL.URL +'/api/workflow/:idWorkflow/:action/:idAction', { idWorkflow: '@idWorkflow', action: '@action', idAction: '@idAction' }, {
            queryPaged: {
                method: 'GET'
            },
            query: {
                method: 'GET', isArray: false
            },
            update: {
                method: 'PUT'
            }
        });


        vm.resourceGetTask = $resource(URL.URL + '/api/workflow/:idWorkflow/:action?name=:name', { idWorkflow: '@idWorkflow', action: '@action', name: '@name' }, {
            queryPaged: {
                method: 'GET'
            },
            query: {
                method: 'GET', isArray: false
            },
            update: {
                method: 'PUT'
            }
        });


        vm.resourceTree = $resource(URL.URL +'/api/workflow/tree',{}, {
            query: {
                method: 'GET', isArray: true
            }
        });



        vm.numAlerts = $resource(URL.URL +'/api/alertmetadatafilecontainers/noreadtotal');

        vm.menuAlerts = $resource(URL.URL +'/api/alertmetadatafilecontainers/menu', {
            'query': { method: 'GET', isArray: true }
        });
    }

    workflowService.$inject = ["$resource","URL"];

    angular.module("solpheo").service("solpheo.workflowService", workflowService);
}());